import { IBook } from 'marketing-site/@types/generated/contentful'
import BookOrGuidePageContent from './book'

export interface IProps {
  book: IBook
}

export default BookOrGuidePageContent
